export default defineNuxtPlugin({
  name: 'phs:track-page-load',
  setup(nuxtApp) {
    const { dataLayerPush } = useAnalyticsTracking()

    // We only want to emit this event once.
    const hasTracked = useState('has_tracked_page_load', () => false)

    // This is the case during client side hydration: The event was already
    // pushed during SSR.
    if (hasTracked.value) {
      return
    }

    // The event is emitted by useDrupalRoute().
    nuxtApp.hooks.hookOnce('drupal-route', (ctx) => {
      if (!ctx.drupalRoute) {
        return
      }

      if (hasTracked.value) {
        return
      }

      dataLayerPush({ entityId: ctx.drupalRoute.entityId })
      hasTracked.value = true
    })
  },
})
